exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".VdkB7mpEV0{font-size:22px;font-weight:700;position:relative;box-sizing:border-box;height:3pc;padding-top:13px;text-align:center;text-transform:uppercase;letter-spacing:1px;color:#fff;background-color:#2ab8d5}.VdkB7mpEV0 a{color:#fff;text-decoration:none}._3WAEyU6y3Q{position:absolute;top:2px;padding:10px;cursor:pointer;color:#fff}._2WVqXhc_DO{right:0}._1pFf7-2SCC{left:0}._1pFf7-2SCC .icon{transform:rotate(180deg)}", ""]);

// exports
exports.locals = {
	"main": "VdkB7mpEV0",
	"nav": "_3WAEyU6y3Q",
	"nav--next": "_2WVqXhc_DO",
	"nav--prev": "_1pFf7-2SCC"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!./~/postcss-loader!./~/sass-loader?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./src/react/components/CardHeader/CardHeader.scss
// module id = 670
// module chunks = 5 34 37